/* Component Dependencies */
var erfpRequestedPropertiesTemplate = require('templates/erfpRequestedProperties.hbs');
var AriesComponent = require('libs/aries-component');
var ResponsiveUtils = require('utils/responsiveUtils');
var GoogleApi = require('libs/google-api');
var MapHandler = require('libs/google-map-handler');
var MapConfig = require('libs/googleMapConfig');
var googleApiWrapper = require('js-google-api-wrapper');
var MarkerClusterer = require('marker-clusterer-plus');
var baiduCluster = require('libs/baidumaps/map-cluster');
var Popup = require('libs/popup');
var Constants = require('libs/constants');

AriesComponent.create({
  type: 'erfpRequestedProperties',
  template: {
    'erfpRequestedProperties': erfpRequestedPropertiesTemplate
  },
  mapData: {
    properties: []
  },
  events: {
    'click .js-remove-hotels': 'removeHotel',
    'click .js-undo-hotel': 'undoHotel',
    'click .js-hotel-button ,.js-hotel-accordion': 'showHotelDetails',
    'click .js-close-button': 'closeHotelOverlay'
  },
  bindEvents: function () {
    var _self = this;
    this.hotelSelected = [];
    this.undoPropertyRemoval = false;
    this.markerData = [];
    this.hotelDeleted = [];
    this.pointsArray = [];
    _self.markers = [];
    this.removedBaiduMarker = [];
    this.createHotelElement();
    this.handleTabFocus();
    this.responsiveUtils = ResponsiveUtils.create();
    this.responsiveUtils.init();
    _self.registerPopUp();
    if (_self.$el.hasClass('js-baidu-map')) {
      _self.initBaidu();
    } else {
      _self.loadMapApi();
      $(window).on('resize', function () {
        google.maps.event.trigger(_self.hotelMap, 'resize');
        _self.setMapView();
        _self.hotelDescriptionHeightHandler();
      })
    }
  },

  /* Register Pop up */
  registerPopUp: function () {
    if (this.$el.find('.t-promos-title').length) {
      var showPopup = new Popup({
        sourceBlock: '.modal-content',
        selector: '.mi-popover'
      });
      showPopup.register();
    }
  },
  /*Push Element into Array*/
  pushElementIntoArray: function (hotelElement) {
    var hotelObj = {};
    if ($(hotelElement).data('hotel-id') != undefined) {
      hotelObj['hotel-id'] = $(hotelElement).data('hotel-id');
      this.hotelSelected.push(hotelObj);
    }
  },
  /*Creating Selected Hotel Array on Init*/
  createHotelElement: function () {
    var _self = this;
    this.$el.find('.l-hotel-description').each(function (hotelKey, hotelElement) {
      if (!$(hotelElement).hasClass('l-hotel-undo')) {
        _self.pushElementIntoArray(hotelElement);
      }
    });
    this.checkCrossButton();
    this.hotelButtonText();
    this.hotelCompareButton();
  },
  /*Changing Button text name based on hotel selected*/
  changeButtonName: function (name) {
    this.$el.find('.js-hotel-button').children('.t-hotel-btn-name').text(name);
    this.$el.find('.tile-s-hotel-compare h4').text(name);
    this.$el.find('.l-overlay-heading p').text(name);
  },
  /*Returning Array Length Selected Hotel*/
  checkSelectedArrayLength: function () {
    return this.hotelSelected.length;
  },
  /*Checking Selected Array Size and changing Button Name*/
  hotelButtonText: function () {
    var buttontext = this.checkSelectedArrayLength() > 1 ? this.$el.find('.js-hotel-button').data('hotel-compare-btn') : this.$el.find('.js-hotel-button').data('hotel-detail-btn');
    this.changeButtonName(buttontext);
  },
  /*Checking Selected Array Size and toggling compare count*/
  hotelCompareButton: function () {
    var compareButton = this.checkSelectedArrayLength() > 1 ? this.$el.find('.l-hotel-compare-count').show() : this.$el.find('.l-hotel-compare-count').hide();
  },
  /*Check cross Button on remove hotel*/
  checkCrossButton: function () {
    if (this.checkSelectedArrayLength() == 1) {
      this.$el.find('.js-remove-hotels').addClass('l-display-none');
    }
  },
  /*Cross Button Additon after Undo*/
  addCrossButtonAfterUndo: function () {
    this.$el.find('.l-hotel-description').each(function (hotelKey, hotelElement) {
      if (!$(hotelElement).hasClass('l-hotel-undo')) {
        $(hotelElement).find('.js-remove-hotels').removeClass('l-display-none');
      }
    });
  },
  /*Select Element From Dom */
  selectElementFromDom: function (event) {
    var $el = $(event.currentTarget).closest('.l-hotel-description');
    return $el;
  },
  /*Add Element in Array*/
  addElementIntoArray: function (event) {
    var hotelObj = {},
      $el = this.selectElementFromDom(event);
    hotelObj['hotel-id'] = $el.data('hotel-id');
    return hotelObj;
  },
  /*Undo/remove hotel API call*/
  sendApiCall: function (url, data) {
    this.makeAjaxCall({
      url: url,
      method: 'POST',
      data: JSON.stringify(data),
      contentType: 'application/json',
    }).then(function (response) { });
  },
  /*Remove Hotel CTA*/
  removeHotel: function (event) {
    var $el = this.selectElementFromDom(event),
      obj = {},
      url,
      _self = this,
      $removeBtn = $el.find('.js-remove-hotels');
      obj[$removeBtn.data('label')] = $el.find('.js-remove-hotels').data('key');
      obj[$removeBtn.data('marshacodekey')] = $el.data("hotel-id");
      url = $removeBtn.data('url');
    if (!_self.$el.hasClass('js-baidu-map')) {
      this.hotelDeleted.push(this.addElementIntoArray(event));
      this.removeElementFromArray(this.hotelSelected, $el.data("hotel-id"));
    }
    this.blurHotelDetails($el);
    this.hotelButtonText();
    this.hotelCompareButton();
    this.checkCrossButton();
    this.removeMarkerFromMap($el);
    this.sendApiCall(url,obj);
  },

  /*Undo Hotel CTA*/
  undoHotel: function (event) {
    event.preventDefault();
    var $el = this.selectElementFromDom(event),
      obj = {}, url, _self = this,
      $undoBtn = $el.find('.js-undo-hotel');
    obj[$undoBtn.data('label')] = $el.find('.js-undo-hotel').data('key');
    obj[$undoBtn.data('marshacodekey')] = $el.data("hotel-id");
    url = $undoBtn.data('url');
    if(!_self.$el.hasClass('js-baidu-map')){
      this.hotelSelected.push(this.addElementIntoArray(event));
      this.removeElementFromArray(this.hotelDeleted, $el.data("hotel-id"));
    }
    this.removeBlurFromHotel($el);
    this.hotelButtonText();
    this.hotelCompareButton();
    this.addCrossButtonAfterUndo();
    this.addMarkerOnMap($el);
    this.sendApiCall(url,obj);
  },
  /*Blur Hotel Details on Cross Click*/
  blurHotelDetails: function ($el) {
    $el.addClass('l-hotel-undo');
    $el.find('.js-remove-hotels').addClass('l-display-none');
    $el.find('.js-undo-hotel').removeClass('l-display-none');

  },
  /*Remove Blur From Hotel Details on Undo Click*/
  removeBlurFromHotel: function ($el) {
    $el.removeClass('l-hotel-undo');
    $el.find('.js-remove-hotels').removeClass('l-display-none');
    $el.find('.js-undo-hotel').addClass('l-display-none');
  },
  /*Remove Element From Array*/
  removeElementFromArray: function (arr, val) {
    for (var i = 0; i < arr.length; i++) {
      if (arr[i]["hotel-id"] == val) {
        arr.splice(i, 1);
        break;
      }
    }
  },
  /*handle Tab focus in expanded state*/
  handleTabFocus: function () {
    var _self = this;
    _self.$el.on('keydown', '.js-hotel-button', function (e) {
      if (e.keyCode == 9) {
        if (_self.$el.find('.t-overlay-style .js-hotel-button').length) {
          if (_self.$el.find('.l-position-handling').length) {
            $(this).next().focus();
          } else {
            $('.l-upper-header a').first().focus();
          }
        }
      }
    });
  },
  /* shows the expanded view of hotels selected */
  showHotelDetails: function (event) {
    var _self = this,
      $parent = _self.$el,
      closeText = $parent.find('.js-hotel-button').data('close');
    if ($parent.hasClass('is-collapsed')) {
      $parent.removeClass('is-collapsed');
      $parent.find('.l-expanded-details').removeClass('is-hidden');
      $parent.find('.l-collapsed-details').addClass('is-hidden');
      this.hotelDescriptionHeightHandler();
      $parent.find('.l-map').slideDown(500, function () {
        _self.setMapView();
      });
      $parent.find('.l-hotel-details-container').removeClass('is-visible-m');
      $parent.find('.t-hotel-btn-name').toggleClass('is-hidden');
      $parent.find('.l-close-text').toggleClass('is-hidden');
      $parent.find('.t-icon-arrow-down').removeClass('t-icon-arrow-down').addClass('t-icon-arrow-up');
      $parent.find('.l-hotel-details-container').addClass('t-overlay-style t-bg-standard-20');
      $parent.find('.l-content-cover').toggleClass('is-hidden');
      if ($(event.currentTarget).hasClass('js-hotel-accordion')) {
        $('body').addClass('overlay-phone-handling');
      }
    }
    else {
      _self.closeHotelOverlay();
    }
  },
  /* closes the expanded view of hotels selected*/
  closeHotelOverlay: function () {
    var _self = this,
      $parent = _self.$el,
      $document = $('html, body');
    $parent.addClass('is-collapsed');
    $parent.find('.l-expanded-details').addClass('is-hidden');
    $parent.find('.l-collapsed-details').removeClass('is-hidden');
    $parent.find('.l-map').slideUp(500);
    $parent.find('.l-hotel-details-container').addClass('is-visible-m');
    $parent.find('.t-hotel-btn-name').toggleClass('is-hidden');
    $parent.find('.l-close-text').toggleClass('is-hidden');
    $parent.find('.t-icon-arrow-up').toggleClass('t-icon-arrow-down').toggleClass('t-icon-arrow-up');
    $parent.find('.l-hotel-details-container').removeClass('t-overlay-style t-bg-standard-20');
    $parent.find('.l-content-cover').toggleClass('is-hidden');
    $document.animate({ scrollTop: 0 }, 10);
    $document.removeClass('overlay-phone-handling');
  },
  /*loads map with map url and render hotel markers*/
  loadMapApi: function () {
    var _self = this;
    googleApiWrapper.loadApi(_self.$el.find('.l-map-container').data('googlemapurl'))
      .then(function () {
        _self.initHotelMap();
      });
  },
  /* initialize hotel map  with map controls*/
  initHotelMap: function () {
    var _self = this;
   _self.createMapObject();
   _self.renderHotelMarkers();
  },
  createMapObject: function (center) {
    var _self = this;
    _self.hotelMap = new google.maps.Map(_self.$el.find('.l-map-container')[0], {
      center: { lat: 0, lng: 0 },
      streetViewControl: false,
      mapTypeControl: false,
      fullscreenControl: false,
      clickableIcons: MapConfig.mapProps.clickableIcons,
      zoomControl: true,
      zoom: MapConfig.markerProps.zoom
    });
  },
  /**
   * This function render markers on map for each hotel
   */
  renderHotelMarkers: function () {
    var _self = this,
      i,
      hotelDetails = [],
      hotelObj = {},
      markerCluster,
      name,
      requestedHotels = _self.$el.find('.l-nearby-airport'),
      pinUrl = _self.$el.find('.l-map-container').data('img').pinMap,
      clusterUrl = _self.$el.find('.l-map-container').data('img').pinCluster,
      hotelLen = requestedHotels.length;
    _self.markers = [];
    _self.removedMarkers = [];

    _self.locations = new google.maps.LatLngBounds();

    MapConfig.markerProps.hotelIcon.url = pinUrl;
    MapConfig.clusterProps.styles[0].url = clusterUrl;

    for (i = 0; i < hotelLen; i++) {
      hotelDetails.push(
        {
          lat: requestedHotels.eq(i).data('latitude'),
          long: requestedHotels.eq(i).data('longitude'),
          hotelname: requestedHotels.eq(i).data('hotel-name'),
          hotelid: requestedHotels.eq(i).data('hotel-id'),
          isDeleted: requestedHotels.eq(i).hasClass('l-hotel-undo')
        }
      )
    }

    for (i = 0; i < hotelLen; i++) {
      hotelObj = {};
      hotelObj['hotel-id'] = hotelDetails[i].hotelid;
      hotelObj['marker'] = _self.createHotelMarker(hotelDetails[i]);
      if (hotelDetails[i].isDeleted) {
        _self.removedMarkers.push(hotelObj);
      }
      else {
        _self.markers.push(hotelObj);
      }
      _self.locations.extend(hotelObj["marker"].getPosition());
    }

    _self.createMarkerCluster();

  },
  /* This function creates and return markers for selected hotels*/
  createHotelMarker: function (hotelData) {
    var _self = this,
      propertyName,
      position = new google.maps.LatLng(hotelData.lat, hotelData.long),
      hoteLength,
      hoteName = hotelData.hotelname,
      lang = $('html').attr('lang');
    switch(lang) {
      case Constants.LOCALE.KOREAN:
      case Constants.LOCALE_HYPHEN.KOREAN:
        hoteLength = MapConfig.markerProps.hotelLengthKr;
        break;
      case Constants.LOCALE.JAPANESE :
      case Constants.LOCALE_HYPHEN.JAPANESE :
        hoteLength = MapConfig.markerProps.hotelLengthJp;
        break;
      case Constants.LOCALE.RUSSIAN :
      case Constants.LOCALE_HYPHEN.RUSSIAN :
        hoteLength = MapConfig.markerProps.hotelLengthRu;
        break;
      default:
        hoteLength = MapConfig.markerProps.hotelLength;
    }
    ( hoteName.length > hoteLength ) ? ( propertyName = hoteName.substring(0, hoteLength) + "\u2026" ) : ( propertyName = hoteName );

    return new google.maps.Marker({
      position: { lat: hotelData.lat, lng: hotelData.long },
      label: {
        color: MapConfig.markerProps.color,
        text: propertyName ? propertyName : " ",
        fontSize: MapConfig.markerProps.hotelFont,
        lineHeight: MapConfig.markerProps.hotelLineHeight
      },
      icon: MapConfig.markerProps.hotelIcon,
      zIndex: 1,
      optmized: false
    });
  },
  /* This function creates Map cluster from all hotel markers*/
  createMarkerCluster: function () {
    var _self = this,
      markers = [],
      i,
      markerLen = _self.markers.length;

    for (i = 0; i < markerLen; i++) {
      markers.push(_self.markers[i]['marker']);
    }

    _self.markerCluster = new MarkerClusterer(_self.hotelMap, markers, MapConfig.clusterProps);
  },
  /*Renders markers of all neighbouring aiports of a particular hotel*/
  renderAirportMarkers: function () {
    var _self = this,
      airportCodes,
      hotelDetails = [],
      i,
      j,
      request = {},
      airportLen,
      requestedHotels = _self.$el.find('.l-nearby-airport'),
      hotelLen = requestedHotels.length,
      marker,
      service = new google.maps.places.PlacesService(_self.hotelMap),
      hotelObj;
    _self.removedAirportMarkers = [];
    _self.airportMarkers = [];


    for (i = 0; i < hotelLen; i++) {
      hotelDetails.push(
        {
          lat: requestedHotels.eq(i).data('latitude'),
          long: requestedHotels.eq(i).data('longitude'),
          airportCodes: requestedHotels.eq(i).data('airport-codes'),
          hotelId: requestedHotels.eq(i).data('hotel-id'),
          isRemoved: requestedHotels.eq(i).hasClass('l-hotel-undo')
        }
      )
    }

    for (i = 0; i < hotelLen; i++) {
      airportLen = hotelDetails[i].airportCodes.length;
      hotelObj = {};
      hotelObj['hotel'] = hotelDetails[i].hotelId;
      hotelObj['markers'] = [];
      if (hotelDetails[i].isRemoved) {
        _self.removedAirportMarkers.push(hotelObj);
      } else {
        _self.airportMarkers.push(hotelObj);
      }
      for (j = 0; j < airportLen; j++) {
        request = {};
        request.location = { lat: hotelDetails[i].lat, lng: hotelDetails[i].long };
        request.radius = MapConfig.markerProps.radius;
        request.type = ['airport'];
        request.keyword = hotelDetails[i].airportCodes[j];

        _self.filterNearbyAirports(request, hotelObj, hotelDetails[i].isRemoved);
      }
    }
  },
  /* Returns the filtered airport results based on airport codes provided */
  filterNearbyAirports: function (request, hotelObject, isHotelRemoved) {
    var _self = this,
      service = new google.maps.places.PlacesService(_self.hotelMap),
      marker,
      airportMarker;

    service.nearbySearch(request, function (results, status) {

      if (status === google.maps.places.PlacesServiceStatus.OK) {
        marker = _self.createAirportMarker(results, request);
        airportMarker = {};
        airportMarker.code = request.keyword;
        airportMarker.marker = marker;
        hotelObject.markers.push(airportMarker);
        if (!isHotelRemoved) {
          marker.setMap(_self.hotelMap);
        }
      }
    })

  },
  /* Creates and returns airport marker */
  createAirportMarker: function (results, code) {
    var _self = this,
      place = results[0].geometry.location,
      marker,
      airportUrl = _self.$el.find('.l-map-container').data('img').pinAirport,
      airportUrlMobile = _self.$el.find('.l-map-container').data('img').pinAirportMobile;

    MapConfig.markerProps.airportIcon.url = airportUrl;

    if (this.responsiveUtils.isMobile()) {
      marker = new google.maps.Marker({
        position: place,
        icon: airportUrlMobile,
        zIndex: -1,
        optimized: false
      });

    } else {
      marker = new google.maps.Marker({
        position: place,
        label: {
          color: MapConfig.markerProps.color,
          text: code.keyword,
          fontSize: MapConfig.markerProps.hotelFont,
          fontWeight: MapConfig.markerProps.hotelFontWeight,
        },
        zIndex: -1,
        optimized: false,
        icon: MapConfig.markerProps.airportIcon
      });
    }
    _self.locations.extend(marker.getPosition());
    return marker;
  },
  /* Removes the respective hotel marker from the map whose remove button is clicked*/
  removeMarkerFromMap: function (hotel) {
    var _self = this,
      hotelKey = hotel.data('hotel-id'),
      removedMarker,
      i,
      j,
      markerLen = _self.markers.length;
    if (_self.$el.hasClass('js-baidu-map')) {
      var clusterCount = this.markerCluster.getClusters();
      if(clusterCount) {
      this.markerCluster.clearMarkers();
        _self.initializeLatLong();
      } else {
        for (i = 0; i < this.markers.length; i++) {
          _self.map.removeOverlay(this.markers[i]);
        }
      }
    } else {
      for (i = 0; i < markerLen; i++) {
        if (_self.markers[i]['hotel-id'] === hotelKey) {
          removedMarker = _self.markers[i]['marker'];
          _self.removedMarkers.push(_self.markers[i]);
          _self.markers.splice(i, 1);
          break;
        }
        if (_self.airportMarkers && _self.airportMarkers[i]['hotel'] === hotelKey) {
          airportLen = _self.airportMarkers[i]['markers'].length;
          for (j = 0; j < airportLen; j++) {
            _self.airportMarkers[i]['markers'][j].marker.setMap(null);
          }
          _self.removedAirportMarkers.push(_self.airportMarkers[i]);
          _self.airportMarkers.splice(i, 1);
          break;
        }
      }
      _self.markerCluster.setMap(null);
      removedMarker.setMap(null);
      _self.createMarkerCluster();
    }
  },
  /* Adds the respective hotel marker on map whose undo button is clicked*/
  addMarkerOnMap: function (hotel) {
    var _self = this,
      hotelKey = hotel.data('hotel-id'),
      undoMarker,
      i,
      j,
      airportLen,
      markerLen = _self.$el.hasClass('js-baidu-map') ? 0 : _self.removedMarkers.length;

      if(_self.$el.hasClass('js-baidu-map')){
        this.undoPropertyRemoval = true;
        _self.initializeLatLong();
        for (i = 0; i < this.markers.length; i++) { 
          _self.map.addOverlay(this.markers[i]);
        }
        this.undoPropertyRemoval = false;
    } else {
      for (i = 0; i < markerLen; i++) {
        if (_self.removedMarkers[i]["hotel-id"] === hotelKey) {
          undoMarker = _self.removedMarkers[i]['marker'];
          _self.markers.push(_self.removedMarkers[i]);
          _self.removedMarkers.splice(i, 1);
          break;
        }
      }
      undoMarker.setMap(_self.hotelMap);
      _self.markerCluster.setMap(null);
      if (_self.markers.length > 1)
        _self.createMarkerCluster();
    }
  },
  /*Resizes the map on basis of locations of all markers*/
  setMapView: function () {
    var _self = this;
    if (!_self.$el.hasClass('js-baidu-map')) {
      this.hotelMap.fitBounds(_self.locations);
      if (this.hotelMap.zoom > 17) {
				this.hotelMap.setZoom(17);
			}
    } else {
      _self.initBaidu();
    }
  },
  /* changes airport icon during window resize*/
  airportMarkerResizeHandler: function () {
    var _self = this,
      i,
      j,
      markerLen = _self.airportMarkers.length,
      removedMarkerLen = _self.removedAirportMarkers.length,
      airportLen,
      removedAirportLen,
      label = { color: MapConfig.markerProps.color, fontSize: MapConfig.markerProps.hotelFont },
      airportUrl = _self.$el.find('.l-map-container').data('img').pinAirport,
      airportUrlMobile = _self.$el.find('.l-map-container').data('img').pinAirportMobile,
      icon = { url: airportUrl, labelOrigin: MapConfig.markerProps.airportIcon.labelOrigin };

    if (this.responsiveUtils.isMobile()) {
      for (i = 0; i < markerLen; i++) {
        airportLen = _self.airportMarkers[i]['markers'].length;
        for (j = 0; j < airportLen; j++) {
          _self.airportMarkers[i]['markers'][j].marker.setLabel(" ");
          _self.airportMarkers[i]['markers'][j].marker.setIcon(airportUrlMobile);
        }
      }
      for (i = 0; i < removedMarkerLen; i++) {
        airportLen = _self.removedAirportMarkers[i]['markers'].length;
        for (j = 0; j < airportLen; j++) {
          _self.removedAirportMarkers[i]['markers'][j].marker.setLabel(" ");
          _self.removedAirportMarkers[i]['markers'][j].marker.setIcon(airportUrlMobile);
        }
      }
    } else {
      for (i = 0; i < markerLen; i++) {
        airportLen = _self.airportMarkers[i]['markers'].length;
        for (j = 0; j < airportLen; j++) {
          label.text = _self.airportMarkers[i]['markers'][j].code;
          _self.airportMarkers[i]['markers'][j].marker.setLabel(label);
          _self.airportMarkers[i]['markers'][j].marker.setIcon(icon);
        }
      }
      for (i = 0; i < removedMarkerLen; i++) {
        airportLen = _self.removedAirportMarkers[i]['markers'].length;
        for (j = 0; j < airportLen; j++) {
          label.text = _self.removedAirportMarkers[i]['markers'][j].code;
          _self.removedAirportMarkers[i]['markers'][j].marker.setLabel(label);
          _self.removedAirportMarkers[i]['markers'][j].marker.setIcon(icon);
        }
      }

    }
  },
  hotelDescriptionHeightHandler: function () {
    var _self = this,
      maxNameHeight = 0,
      maxAddressHeight = 0,
      i,
      hotelName = _self.$el.find('.l-hotel-name'),
      hotelAddress = _self.$el.find('.l-hotel-address');
    hotelLen = hotelName.length;
    if (this.responsiveUtils.isMobile()) {
      hotelAddress.css({ "min-height": "initial" });
      hotelName.css({ "min-height": "initial" });
    } else {
      for (i = 0; i < hotelLen; i++) {
        if (hotelAddress.eq(i).children().height() > maxAddressHeight) {
          maxAddressHeight = hotelAddress.eq(i).children().height();
        }
        if (hotelName.eq(i).children().height() > maxNameHeight) {
          maxNameHeight = hotelName.eq(i).children().height();
        }
      }
      hotelAddress.css({ "min-height": maxAddressHeight });
      hotelName.css({ "min-height": maxNameHeight });
    }
  },
  initBaidu: function () {

    var _self = this;
    _self.map = new BMap.Map("baidumap");
    _self.markersBaidu = [];
    _self.pin = _self.$el.find('.js-regional-map').data().img;
    var propertyList = _self.$el.find('.l-nearby-airport');
    for (i = 0; i < propertyList.length; i++) {
      this.pointsArray.push(new BMap.Point(propertyList.eq(i).data('longitude'), propertyList.eq(i).data('latitude')));
    }
    var mapCenter = _self.map.getViewport(this.pointsArray);
    var offset = {
      type: BMAP_NAVIGATION_CONTROL_SMALL,
      anchor: BMAP_ANCHOR_TOP_LEFT
    };
    _self.map.centerAndZoom(mapCenter.center, mapCenter.zoom);
    _self.map.addControl(new BMap.NavigationControl(offset));
    _self.map.enableScrollWheelZoom();
    _self.initializeLatLong();
    _self.map.addEventListener('zoomend',function(){
      if(_self.markerCluster){
         _self.map.clearOverlays();
         _self.markerCluster.clearMarkers();
         _self.initializeLatLong();
      }
  });
  _self.map.addEventListener('moveend',function(){
      if(_self.markerCluster){
        _self.map.clearOverlays();
        _self.markerCluster.clearMarkers();
        _self.initializeLatLong();
      }
  });

  },
  initializeLatLong: function () {
    var _self = this;
    var rfpHotels = _self.$el.find('.l-nearby-airport');
    this.markerData = [];
    for (i = 0; i < rfpHotels.length; i++) {
      this.markerData.push(
        {
          lat: rfpHotels.eq(i).data('latitude'),
          long: rfpHotels.eq(i).data('longitude'),
          hotelname: rfpHotels.eq(i).data('hotel-name'),
          hotelid: rfpHotels.eq(i).data('hotel-id'),
          isDeleted: rfpHotels.eq(i).hasClass('l-hotel-undo')
        });
    }
    _self.createBaiduLabel(this.markerData);
  },

  createBaiduLabel: function _createBaiduLabel(markerData) {
    var baiduMarker;
    var iconBaidu = new BMap.Symbol(BMap_Symbol_SHAPE_CIRCLE, {
      scale: 0.1,
      strokeWeight: 0.1,
      strokeOpacity: 0,
      fillColor: '#494949',
      fillOpacity: 0
    });
    this.map.clearOverlays();
    this.markers = [];
    for (var i = 0; i < markerData.length; i++) {
      if(!markerData[i].isDeleted) {
      baiduMarker = new BMap.Marker(new BMap.Point(markerData[i].long, markerData[i].lat),{
        icon: iconBaidu
      });
      var hotelName = markerData[i].hotelname ? markerData[i].hotelname : markerData[i].customData.hotelname;
      this.label = new BMap.Label('<div class="map-marker map-marker-default blank"><div class="map-rate-details">' + hotelName + '</div><div class="arrow"></div></div>',{
        offset: new BMap.Size(-88, -39)
      });
      this.label.setStyle({
        background: 'none',
        color: '#fff',
        contentAlign:'center',
        border: 'none',
        width: '180px'
      });
      this.label.setPosition(new BMap.Point(markerData[i].long, markerData[i].lat));
      baiduMarker.customData=markerData[i];
      baiduMarker.customData.indexBaidu=i;
      this.label.customData= baiduMarker.customData;
      this.label.customData.marker=baiduMarker;
      baiduMarker.setLabel(this.label);
      this.markers.push(baiduMarker);
      }
    }
    if(!this.undoPropertyRemoval) {
      this.createBaiduCluster(this.markers);
    }
  },

  createBaiduCluster: function(markerArray){
    var clusterUrl = this.$el.find('.l-map-container').data('img').pinCluster;
    this.markerCluster = new baiduCluster.BMapLib.MarkerClusterer(this.map,
      {
        markers: markerArray,
        styles: [{
          url: clusterUrl,
          size: new BMap.Size(72, 72),
          opt_anchor: [32, 0],
          textColor: 'white',
          opt_textSize: 14
        }],
        openInfoWindow: false
      });
  }
});
